import React from 'react';
import ConteoDenominaciones from './ConteoDenominaciones';
import { useSucursal } from '../contexts/SucursalContext';

/**
 * Componente para apertura directa de caja usando conteo de denominaciones
 * Este componente reemplaza completamente el flujo anterior de IniciarCaja
 */
const AperturaCajaDirecta = ({ open, onClose }) => {
    const { cajaAbierta } = useSucursal();

    const handleConteoCompleto = () => {
        onClose();
    };

    // Si la caja ya está abierta, no mostrar el modal
    if (cajaAbierta && open) {
        return null;
    }    return (
        <ConteoDenominaciones
            open={open}
            onClose={handleConteoCompleto}
            tipoOperacion="APERTURA"
            idCajaEncabezado={null} // Siempre null para crear nueva caja
        />
    );
};

export default AperturaCajaDirecta;
